interface DtoValidationError {
  error: Record<string, string>;
}

export function isDtoValidationError(err: unknown): err is DtoValidationError {
  const hasErrorField =
    typeof err === 'object' &&
    err !== null &&
    typeof (err as { error: unknown }).error === 'object' &&
    (err as { error: unknown }).error !== null;

  if (!hasErrorField) {
    return false;
  }

  const allValuesAreString = Object.values(
    (err as { error: Record<string, unknown> }).error,
  ).every(v => typeof v === 'string');
  return allValuesAreString;
}

export function isStandardError(err: unknown): err is { error: string } {
  return (
    typeof err === 'object' &&
    err !== null &&
    typeof (err as Record<string, unknown>).error === 'string'
  );
}

export function getDtoErrors(err: unknown): string[] {
  if (!isDtoValidationError(err)) {
    return ['Unknown error.'];
  }

  return Object.values(err.error);
}
